import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleEmployee } from '../../../Store/PHPSlice/Employee';
import { Preview } from '@mui/icons-material';


const TableBody = ({
    id,
    serialNumber,
    date,
    employeeName,
    contactNo,
    emailId,
    category,
    departNm,
    teamleader,
    paymentType,
    pType,
    tl,
    team_sts,
    teamNm,
    departName,
    locId,
    adrs,
    locNm,
    payAmt,
    punchId,
    panNo,
    gstNo,
    selected,

    handleClick,
}) => {

    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/EmployeeEdit/${id}`, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        const isConfirmed = window.confirm("Are you sure you want to delete this Employee?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleEmployee(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast("Employee Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting company:", error);
                    toast.error("Failed to delete company");
                });
        }
    };

    const handleEmpDepartClick = () => {
        window.open(`/emp-depart-view/${id}`, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');
    }

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>


                <TableCell component="th" scope="row" sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                    <Typography variant="subtitle2" noWrap>
                        {employeeName}
                    </Typography>

                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{locNm}</TableCell>

                <TableCell component="th" scope="row" sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                    <Typography variant="subtitle2" noWrap>
                        {contactNo}
                    </Typography>

                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{adrs === '0' ? '' : adrs}</TableCell>


                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{emailId}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{punchId}</TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{gstNo}</TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{panNo}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {teamNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {pType}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {payAmt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', width: '15vw' }} align='center'>
                    {departName}
                </TableCell>

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <Preview className='cursor-pointer' onClick={handleEmpDepartClick} />
                </TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
